import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('a-card', {
    ref: "searchExpand",
    staticClass: "search-card",
    attrs: {
      "title": "筛选",
      "size": "small"
    }
  }, [_c('div', {
    class: _vm.search
  }, [_c('a-form-model', {
    ref: "searchFrom",
    attrs: {
      "model": _vm.formState,
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol
    }
  }, [_c('div', {
    class: _vm.expand ? null : 'fold'
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "功能模块",
      "prop": "noticeType"
    }
  }, [_c('a-select', {
    ref: "select",
    attrs: {
      "placeholder": "请选择功能模块"
    },
    model: {
      value: _vm.formState.noticeType,
      callback: function callback($$v) {
        _vm.$set(_vm.formState, "noticeType", $$v);
      },
      expression: "formState.noticeType"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("通知公告")]), _c('a-select-option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("公文流转")]), _c('a-select-option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("报销")]), _c('a-select-option', {
    attrs: {
      "value": 4
    }
  }, [_vm._v("报修")]), _c('a-select-option', {
    attrs: {
      "value": 5
    }
  }, [_vm._v("表单审批")])], 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('a-select', {
    ref: "select",
    attrs: {
      "placeholder": "请选择状态"
    },
    model: {
      value: _vm.formState.status,
      callback: function callback($$v) {
        _vm.$set(_vm.formState, "status", $$v);
      },
      expression: "formState.status"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("待阅")]), _c('a-select-option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("待办")]), _c('a-select-option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("已阅")]), _c('a-select-option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("已办")])], 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "接收日期",
      "prop": "time"
    }
  }, [_c('a-range-picker', {
    attrs: {
      "value-format": "YYYY-MM-DD"
    },
    model: {
      value: _vm.formState.time,
      callback: function callback($$v) {
        _vm.$set(_vm.formState, "time", $$v);
      },
      expression: "formState.time"
    }
  })], 1)], 1)], 1), _c('a-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.expand,
      expression: "expand"
    }]
  }, [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "消息类型",
      "prop": "msgType"
    }
  }, [_c('a-select', {
    ref: "select",
    attrs: {
      "placeholder": "请选择消息类型"
    },
    model: {
      value: _vm.formState.msgType,
      callback: function callback($$v) {
        _vm.$set(_vm.formState, "msgType", $$v);
      },
      expression: "formState.msgType"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("查看类")]), _c('a-select-option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("待办类")])], 1)], 1)], 1)], 1)], 1), _c('span', {
    staticClass: "search-button",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")]), _c('a-button', {
    staticClass: "reset",
    on: {
      "click": function click($event) {
        return _vm.$refs.searchFrom.resetFields();
      }
    }
  }, [_vm._v(" 重置 ")]), _c('a', {
    style: {
      marginLeft: '5px',
      fontSize: '12px'
    },
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v(" " + _vm._s(_vm.expand ? '收起' : '展开') + " "), _c('a-icon', {
    attrs: {
      "type": _vm.expand ? 'up' : 'down'
    }
  })], 1)], 1)])], 1)]), _c('a-card', {
    attrs: {
      "title": "列表",
      "size": "small",
      "bordered": false
    }
  }, [_c('a-table', {
    staticClass: "table-card-view",
    attrs: {
      "size": "middle",
      "columns": _vm.columns,
      "pagination": _vm.pagination,
      "loading": _vm.loading,
      "data-source": _vm.list,
      "bordered": "",
      "row-key": function rowKey(row) {
        return row.id;
      },
      "scroll": {
        y: 500
      }
    },
    on: {
      "change": _vm.change
    },
    scopedSlots: _vm._u([{
      key: "noticeType",
      fn: function fn(noticeType, row) {
        return [1 == row.noticeType ? _c('a-tag', {
          staticStyle: {
            "background-color": "#cde7fd !important",
            "border": "1px solid #018ff0 !important",
            "color": "#018ff0 !important"
          },
          attrs: {
            "color": "#96d682"
          }
        }, [_vm._v(" 通知公告 ")]) : _vm._e(), 2 == row.noticeType ? _c('a-tag', {
          staticStyle: {
            "background-color": "#cde7fd !important",
            "border": "1px solid #018ff0 !important",
            "color": "#018ff0 !important"
          },
          attrs: {
            "color": "#2491fc"
          }
        }, [_vm._v(" 公文流转 ")]) : _vm._e(), 3 == row.noticeType ? _c('a-tag', {
          staticStyle: {
            "background-color": "#cde7fd !important",
            "border": "1px solid #018ff0 !important",
            "color": "#018ff0 !important"
          },
          attrs: {
            "color": "#2491fc"
          }
        }, [_vm._v(" 报销 ")]) : _vm._e(), 4 == row.noticeType ? _c('a-tag', {
          staticStyle: {
            "background-color": "#cde7fd !important",
            "border": "1px solid #018ff0 !important",
            "color": "#018ff0 !important"
          },
          attrs: {
            "color": "#2491fc"
          }
        }, [_vm._v(" 报修 ")]) : _vm._e(), 5 == row.noticeType ? _c('a-tag', {
          staticStyle: {
            "background-color": "#cde7fd !important",
            "border": "1px solid #018ff0 !important",
            "color": "#018ff0 !important"
          },
          attrs: {
            "color": "#2491fc"
          }
        }, [_vm._v(" 表单审批 ")]) : _vm._e()];
      }
    }, {
      key: "msgType",
      fn: function fn(msgType, row) {
        return [1 === row.msgType ? _c('div', [_vm._v("查看类")]) : _vm._e(), 2 === row.msgType ? _c('div', [_vm._v("待办类")]) : _vm._e()];
      }
    }, {
      key: "status",
      fn: function fn(status, row) {
        return [row.msgType == 1 ? _c('div', [0 === row.status ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("待　阅")]) : _vm._e(), 1 === row.status ? _c('a-tag', {
          staticClass: "tag-green"
        }, [_vm._v("已　阅")]) : _vm._e()], 1) : _c('div', [row.auditStatus != null ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("已　办")]) : _vm._e(), row.auditStatus == null ? _c('a-tag', {
          staticClass: "tag-green"
        }, [_vm._v("待　办")]) : _vm._e()], 1)];
      }
    }, {
      key: "action",
      fn: function fn(text, row) {
        return [_c('a-dropdown', {
          attrs: {
            "trigger": ['click']
          }
        }, [_c('a', {
          staticClass: "ant-dropdown-link",
          on: {
            "click": function click(e) {
              return e.preventDefault();
            }
          }
        }, [_vm._v(" 操作 "), _c('a-icon', {
          attrs: {
            "type": "down"
          }
        })], 1), _c('a-menu', {
          attrs: {
            "slot": "overlay"
          },
          slot: "overlay"
        }, [_c('a-menu-item', {
          key: "1"
        }, [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.view(row);
            }
          }
        }, [_vm._v("查看")])], 1), row.noticeType == 5 && row.msgType == 2 && row.auditStatus == null ? _c('a-menu-item', {
          key: "9"
        }, [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.formApproval(row);
            }
          }
        }, [_vm._v("审批")])], 1) : _vm._e(), (row.noticeType == 1 || row.noticeType == 2) && row.msgType == 2 && row.auditStatus == null ? _c('a-menu-item', {
          key: "2"
        }, [(row.tempId === 1 || row.tempId === 2) && row.auditStep === 1 && row.auditStatus !== 1 && row.auditStatus !== 0 ? _c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.firstTrial(row);
            }
          }
        }, [_vm._v(" 初核 ")]) : _vm._e(), row.tempId === 2 && row.auditStep === 2 && row.auditStatus !== 1 && row.auditStatus !== 0 ? _c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.reCheck(row);
            }
          }
        }, [_vm._v(" 复核 ")]) : _vm._e(), row.tempId === 2 && row.auditStep === 3 && row.result === -1 ? _c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.groupSign(row);
            }
          }
        }, [_vm._v(" 会签 ")]) : _vm._e(), row.tempId === 1 && row.auditStep === 2 && row.auditStatus !== 1 && row.auditStatus !== 0 ? _c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.signIssue(row);
            }
          }
        }, [_vm._v(" 签发 ")]) : _vm._e(), row.tempId === 2 && row.auditStep === 4 && row.auditStatus !== 1 && row.auditStatus !== 0 ? _c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.signIssue(row);
            }
          }
        }, [_vm._v(" 签发 ")]) : _vm._e(), row.tempId === 2 && row.auditStep === 5 && row.auditStatus !== 1 && row.auditStatus !== 0 ? _c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.proofread(row);
            }
          }
        }, [_vm._v(" 校对 ")]) : _vm._e(), row.tempId === 2 && row.auditStep === 6 && row.auditStatus !== 1 && row.auditStatus !== 0 ? _c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.printClick(row);
            }
          }
        }, [_vm._v(" 打印 ")]) : _vm._e(), row.auditStep == -1 && row.msgType == 2 ? _c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.viewAudit(row);
            }
          }
        }, [_vm._v(" 审批 ")]) : _vm._e(), row.tempId == 4 && row.msgType == 2 ? _c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.newViewAudit(row);
            }
          }
        }, [_vm._v(" 审批 ")]) : _vm._e()], 1) : _vm._e(), row.noticeType == 4 && row.msgType == 2 && row.auditStatus == null ? _c('a-menu-item', {
          key: "3"
        }, [row.fillStatus == 1 ? _c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.toRepairsDetail(row);
            }
          }
        }, [_vm._v(" 受理 ")]) : _vm._e(), row.fillStatus == 2 ? _c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.toRepairsDetail(row);
            }
          }
        }, [_vm._v(" 派单 ")]) : _vm._e(), row.fillStatus == 3 ? _c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.toRepairsDetail(row);
            }
          }
        }, [_vm._v(" 接单 ")]) : _vm._e(), row.fillStatus == 7 ? _c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.toRepairsDetail(row);
            }
          }
        }, [_vm._v(" 评价 ")]) : _vm._e()], 1) : _vm._e(), row.noticeType == 3 && row.msgType == 2 && row.auditStatus == null ? _c('a-menu-item', {
          key: "10"
        }, [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.auditReimburse(row);
            }
          }
        }, [_vm._v("审核")])], 1) : _vm._e()], 1)], 1)];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };